export class Internationalization {
    refNo: number;
    language: string;
    showCurrencySymbol: boolean;
    currency: string;
    quantityFormat: string;
    rateFormat: string;
    totalFormat: string;
    amountFormat: string;
    showCommaSeparator: boolean;
    userId: string;	

	theme: string;
    navbarBg: string;
    navbarColor: string;

    tabBg: string;
    tabColor: string;
    tabActiveColor: string;

    tableHeaderBg: string;
    tableHeaderColor: string;
    tableBodyBg: string;
    tableBodyColor: string;
    tableHoverBg: string;
    tableFooterBg: string;
    tableFooterColor: string;

    footerBg: string;
    footerColor: string;

    buttonBg: string;
    buttonColor: string;

    scrollbarColor: string;

    spinnerBg: string;
    spinnerColor: string;
    spinnerHover: string;

    checkboxColor: string;
    toggleColor: string;

    iconColor: string;

    dialogBg: string;

    cancelBtnColor: string;
    cancelBtnFontColor: string;

    saveBtnColor: string;
    saveBtnFontColor: string;

    calendarBg: string;
    calendarTextColor: string;
    calendarHeaderBg: string;
    calendarHeaderText: string;
    calendarSelectedColor: string;
    calendarHoverColor: string;
    calendarTodayBorder: string;
    calendarIconColor: string;
    calendarDisabledText: string;

    fromLocationCode?: number;
}